import React, { useRef, useState } from 'react';
import Modal from 'react-bootstrap/Modal';

import useTableScroll from "../components/useTableScroll.js";

import { Mensaje } from '../components/mensajes';
import axios from "axios";
import { Dimmer } from '../components/spinner.jsx';


const CatalogoProveedorPresupuesto = props => {

    let op = require('../../src/modulos/datos');
    let token = localStorage.getItem('jwtToken');
    // const idefiscal = JSON.parse(localStorage.getItem('idefiscal'));

    const btnCancela = useRef();
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [activate, setActivate] = useState(false);
    const [records, setRecords] = useState([]);
    const [values, setValues] = useState({});
    const [activo, setActivo] = useState(true);
    const [itemSelect, setItemSelect] = useState(-1);
    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } })

    const headCells = [
        { id: '1', label: 'NRO. INSCRPCION', textAlign: 'center' },
        { id: '2', label: 'NOMBRE', textAlign: 'center' },
        { id: '3', label: 'RIF', textAlign: 'center' },
        { id: '4', label: 'DIRECCION', textAlign: 'center' },
        { id: '5', label: 'CODIGO', textAlign: 'center' },
    ]

    const {
        TblContainer,
        TblHead,
        TblPagination,
        recordsAfterPagingAndSorting
    } = useTableScroll(records, headCells, filterFn);

    const handleSearch = e => {
        let target = e.target;

        setFilterFn({
            fn: items => {
                if (target.value === "") {
                    return items;
                } else {
                    return items.filter(x => {
                        if ((x.codigo === null ? "" : x.codigo.toLowerCase().includes(target.value.toLowerCase()))
                            || x.razonsocial.toLowerCase().includes(target.value.toLowerCase())
                            || x.rif.toLowerCase().includes(target.value.toLowerCase())
                            || x.direccion.toLowerCase().includes(target.value.toLowerCase())
                            || x.idproveedor.includes(target.value)) {
                            return x;
                        }
                    });
                }
            }
        })

    }

    const seleccionarProveedor = () => {
        let endpoint = `${op.conexion}/api/catalogo/proveedor?tipo=2`;
        setActivate(true);
        axios.get(endpoint, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'

            },
        }).then(function (response) {

            if (response.status === 200) {

                setActivate(false);
                /*var cord = []
                for (let i = 0; i < response.data.length; i++) {
                    cord.push({
                        idproveedor: response.data[i].idproveedor,
                        razonsocial: response.data[i].razonsocial,
                        responsable: response.data[i].responsable,
                        rif: response.data[i].rif
                    })
                }*/
                setRecords(response.data);
            }
        }).catch(function (error) {
            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
        }).finally(function () {
            setActivate(false);
        });
    }
    const blanquear = () => {
        setActivate(false);
        setRecords([]);
        setFilterFn({ fn: items => { return items; } });
        setItemSelect("");
        setActivo(true);
    }
    const cancelar = () => {
        blanquear();
        props.onHideCancelar();
    }
    const selectProveedor = () => {
        var responsable = values[0].responsable;
        var razonsocial = values[0].razonsocial;
        var idproveedor = values[0].idproveedor;
        var rif = values[0].rif;
        blanquear();
        props.onHideAceptaProveedor(responsable, razonsocial, idproveedor, rif);
        props.onHideCancelar();
    };

    const seleccionarFila = (index) => (e) => {
        e.preventDefault();
        setItemSelect(index);
        setActivo(false);

        var responsable = recordsAfterPagingAndSorting()[index].responsable;
        var razonsocial = recordsAfterPagingAndSorting()[index].razonsocial;
        var idproveedor = recordsAfterPagingAndSorting()[index].idproveedor;
        var rif = recordsAfterPagingAndSorting()[index].rif;

        var datos = [];
        datos.push({
            responsable,
            razonsocial,
            idproveedor,
            rif
        })
        setValues(datos);
    };

    return (
        <Modal
            {...props}
            aria-labelledby="contained-modal-title-vcenter"
            centered
            size="lg"
            backdrop="static"
            style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
            keyboard={false}
            onShow={() => {
                seleccionarProveedor()
            }}
        >
            <Modal.Header className='azulGradiant px-4 py-2'>
                <h3 className='fs-4 fw-bold m-0 text-light'>Seleccionar Proveedores</h3>
                <a type='button' ref={btnCancela}
                    className="bg-transpatent fs-6 fw-bold text-light"
                    onClick={cancelar}>
                    salir<i className="fa fa-times ml-2"></i>
                </a>
            </Modal.Header>
            <Modal.Body >
                <Mensaje mensaje={mensaje}
                    onHide={() => setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })} />
                <Dimmer active={activate} inverted>

                </Dimmer>
                <div className="col-6 input-group input-group-sm m-0 mb-2 p-0">
                    <input type='text'
                        onChange={handleSearch}
                        className="form-control rounded-pill search-input search-input" />
                </div>
                <div className="col-12 m-0 p-0">
                    <TblContainer >
                        <TblHead />
                        <tbody>
                            {
                                records && recordsAfterPagingAndSorting().map((item, index) => (
                                    <tr key={index} style={{ padding: "0", cursor: 'pointer', background: itemSelect === index ? "lightskyblue" : "white" }} onClick={seleccionarFila(index)} >
                                        <td className='py-2 text-center' style={{ width: '100px' }}>{item.codigo}</td>
                                        <td className='py-2 text-start' style={{ width: '250px' }}>{item.razonsocial}</td>
                                        <td className='py-2 text-center' style={{ width: '100px' }}>{item.rif}</td>
                                        <td className='py-2 text-center' style={{ width: '300px' }}>{item.direccion}</td>
                                        <td className='py-2 text-center' style={{ width: '100px' }}>{item.idproveedor}</td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </TblContainer>
                    <TblPagination />
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-sm btn-success rounded-pill col-md-2"
                    disabled={activo}
                    onClick={selectProveedor}>
                    Aceptar <i className="fas fa-check-circle"> </i>
                </button>
                <button ref={btnCancela}
                    onClick={cancelar}
                    className="btn btn-sm bg-danger text-light rounded-pill col-md-2">
                    Cancelar <i className="fas fa-window-close"> </i>
                </button>
            </Modal.Footer>
        </Modal>
    );
}

export default CatalogoProveedorPresupuesto;